
export default class Teste {
    constructor(){
        this.perfil = ''
        this.nome = '',
        this.cpf = '',
        this.celular = '',
        this.status = '',
        this.email = '',
        this.senha = '',
        this.plan = '',
        this.pagamento = ''
        this.assinaturasList = []
    }
    setUser(user){
        this.perfil = user.perfil
        this.nome = user.nome
        this.cpf = user.cpf
        this.celular = user.celular
        this.status = user.status
        this.email = user.email
        this.senha = user.senha
        this.plan = user.plan
        this.pagamento = user.pagamento
        this.assinaturasList = user.assinaturasList
    }
}